import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Products from './pages/Products';

function App() {
  return (
    <Router>
      <Helmet>
        <title>SARKAR TRADERS</title>
        <meta name="description" content="SARKAR TRADERS - Your trusted partner in quality products. Located in Domkal, Murshidabad, West Bengal." />
        <meta name="keywords" content="Sarkar Traders, Domkal, Murshidabad, West Bengal, products, trading" />
      </Helmet>
      <div className="App">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/products" element={<Products />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;




